import { Outlet } from 'react-router-dom'
import classes from './Layout.module.css'
import { Header } from './Header'

export default function Layout() {
  return (
    <div className={classes.container}>
      <Header />
      <Outlet />
    </div>
  )
}
